<template>
<div class="c-form_item">
    <template v-if="choices.length > 1">
        <label for="" class="c-form_label" :class="{ '-required': required }">
            {{ labelText }}
        </label>
        <div v-for="(choice, index) in choices" class="c-form_item_group">
            <input ref="checkboxes$" class="c-form_checkbox" type="checkbox" :id="choice.id" :name="name" 
            :value="choice.value"
            @change="validate"
            :checked="modelValue.includes(choice.value)">
            <div class="c-form_validation" :class="{' -hidden': index !== choices.length - 1}">
                <div class="c-form_validation_required">
                    {{ _t("You must select at least one option.") }}
                </div>
                <div class="c-form_validation_invalid">
                    {{ _t("This field is invalid.") }}
                </div>
            </div>
            <label :for="choice.id" class="c-form_checkboxLabel">
                {{ choice.label }}
            </label>
        </div>
    </template>
    <template v-else>
        <input class="c-form_checkbox" type="checkbox" :id="id" :name="name" :value="modelValue"
        @change="$emit('update:modelValue', $event.target.value)" :required="required" :checked="modelValue">
        <div class="c-form_validation">
            <div class="c-form_validation_required">
                {{ _t("Enter a value for this field.") }}
            </div>
            <div class="c-form_validation_invalid">
                {{ _t("This field is invalid.") }}
            </div>
        </div>
        <label :for="id" class="c-form_checkboxLabel">
            {{ labelText }}
        </label>
    </template>
</div>
</template>
<script>
    export default {
        name: 'Checkbox',
        props: {
            id: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            labelText: {
                type: String,
                default: ''
            },
            value: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            choices: {
                type: Array,
                default: []
            },
            modelValue: {
                type: Array,
                default:  []
            }
        },
        //Watch if at least one checkbox is checked else use the invalid attribute on the input
        //on mounted put all the checkboxes setCustomValidity to Invalid
        mounted() {
            if(this.required == true && this.choices.length > 1) {
                let checked = false;

                this.$refs.checkboxes$.forEach(checkbox => {
                    if (checkbox.checked) {
                        checked = true;
                    }
                });

                if (!checked) {
                    this.$refs.checkboxes$.forEach(checkbox => {
                        checkbox.setCustomValidity('Invalid');
                    });
                }

            }
        },
        methods: {
            validate() {
                let checked = false;

                if(this.required == false || this.choices.length < 2) {
                    return;
                }

                this.$refs.checkboxes$.forEach(checkbox => {
                    if (checkbox.checked) {
                        checked = true;
                    }
                });

                if (checked) {
                    this.$refs.checkboxes$.forEach(checkbox => {
                        checkbox.setCustomValidity('');
                    });
                } else {
                    this.$refs.checkboxes$.forEach(checkbox => {
                        checkbox.setCustomValidity('Invalid');
                    });
                }
                this.$emit('update:modelValue', this.$refs.checkboxes$.filter(checkbox => checkbox.checked).map(checkbox => checkbox.value));
            }
        }
    }
</script>

